import React from 'react';
import { Button } from 'primereact/button';

function BackArrow(props) {

  return (

    <div className="col-12 md:col-12" style={{ textAlign: "left" }}>
      <Button icon=" pmi-line pmi-32 pmi-line-arrow-left pj-text-primary-accent-light no-bg" className='p-button-text' aria-label="Cancel" onClick={props.handleBackClick} />
    </div>

  )
}

export default BackArrow
